var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.999939,
    y: 7.01465,
    width: 20,
    height: 18,
    rx: 4.63158,
    stroke: "#3F2C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 20.0147L29.5533 22.2907C29.8633 22.4454 30.2312 22.4287 30.5259 22.2465C30.8206 22.0643 30.9999 21.7425 30.9999 21.396V10.632C31.0002 10.2855 30.8208 9.96359 30.526 9.78152C30.2311 9.59945 29.863 9.58324 29.5533 9.73869L24.9999 12.0147",
    stroke: "#3F2C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingCamera);
export default __webpack_public_path__ + "static/media/meeting-camera.cc65ddb98d264fb618877874bbce9bbc.svg";
export { ForwardRef as ReactComponent };